import { useEffect, useMemo } from "react";
import {
  BufferGeometry,
  Line as ThreeLine,
  LineDashedMaterial,
  Vector3 as ThreeVector3,
} from "three";
import { getEclipseNodes } from "../simulation/geometry";
import type { Vector3 } from "../simulation/types";
import { LabelSprite } from "./LabelSprite";

const NODE_COLOR = "#ffa94d";
const LABEL_COLOR = "#ffd8a8";

export function EclipseNodes() {
  const { ascending, descending } = useMemo(() => getEclipseNodes(), []);

  const lineOfNodes = useMemo(() => {
    const geometry = new BufferGeometry().setFromPoints([
      new ThreeVector3(...ascending),
      new ThreeVector3(...descending),
    ]);
    const material = new LineDashedMaterial({
      color: NODE_COLOR,
      dashSize: 0.32,
      gapSize: 0.2,
      opacity: 0.8,
      transparent: true,
    });
    const object = new ThreeLine(geometry, material);
    object.computeLineDistances();
    return object;
  }, [ascending, descending]);

  useEffect(
    () => () => {
      lineOfNodes.geometry.dispose();
      (lineOfNodes.material as LineDashedMaterial).dispose();
    },
    [lineOfNodes],
  );

  const nodes: readonly { position: Vector3; name: string }[] = [
    { position: ascending, name: "Ascending node" },
    { position: descending, name: "Descending node" },
  ];

  return (
    <group>
      <primitive object={lineOfNodes} />
      {nodes.map(({ position, name }) => (
        <group key={name}>
          <mesh position={position}>
            <sphereGeometry args={[0.15, 24, 16]} />
            <meshBasicMaterial color={NODE_COLOR} />
          </mesh>
          <LabelSprite
            text={name}
            position={[position[0], position[1] + 0.6, position[2]]}
            color={LABEL_COLOR}
          />
        </group>
      ))}
    </group>
  );
}
